// Sets initial scroll position on the calendar grid.
// When scrollToCurrentTime is true and week includes today, scrolls to current time so the line is visible.
// Otherwise uses initialScroll (e.g. 6 AM).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    initialScroll: { type: Number, default: 0 },
    scrollToCurrentTime: { type: Boolean, default: false },
    timeZone: { type: String, default: "UTC" },
    hourHeight: { type: Number, default: 64 }
  }

  connect() {
    let scrollTop = this.initialScrollValue

    if (this.scrollToCurrentTimeValue) {
      const minutes = this.minutesSinceMidnightInZone()
      const topPx = (minutes / 60) * this.hourHeightValue
      // Center the current time in the view, with padding
      const viewportHeight = this.element.clientHeight
      scrollTop = Math.max(0, topPx - viewportHeight / 2 + this.hourHeightValue / 2)
    }

    if (scrollTop > 0) {
      this.element.scrollTop = scrollTop
    }
  }

  minutesSinceMidnightInZone() {
    const tz = this.timeZoneValue || "UTC"
    try {
      const now = new Date()
      const formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: tz,
        hour: "numeric",
        minute: "numeric",
        hour12: false
      })
      const parts = formatter.formatToParts(now)
      const hour = parseInt(parts.find((p) => p.type === "hour")?.value || "0", 10)
      const minute = parseInt(parts.find((p) => p.type === "minute")?.value || "0", 10)
      return hour * 60 + minute
    } catch (e) {
      // Fallback for invalid IANA zone (e.g. Rails names like "Pacific Time (US & Canada)")
      const now = new Date()
      return now.getUTCHours() * 60 + now.getUTCMinutes()
    }
  }
}
